"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    headerTitle: _propTypes.string.isRequired,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      icon: (0, _propTypes.shape)({
        icon: _propTypes.string,
        fontsize: _propTypes.string,
        color: _propTypes.string
      }),
      title: _propTypes.string,
      info: _propTypes.string
    }))
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    data: [],
    headerTitle: 'Ride details'
  }
};
exports.default = _default;